import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { getSessionState } from '@shared/store/selectors';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class IsVerifiedGuard implements CanActivate {
	constructor(
		private store: Store<any>,
		private router: Router
	) {}

	canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> {
		return this.store.pipe(
			select(getSessionState),
			filter(x => x && x.isLoaded),
			switchMap(s => {
				const emailVerified = s.emailVerified;

				if (emailVerified) {
					return of(true);
				}

				return this.router.navigate(['/auth/register/email/pending']);
			})
		);
	}
}
